'use client'

import React from 'react'
import { TrashBin2Broken } from 'solar-icons'

import { useDeleteCart } from '@/lib/hooks/use-saved-orders'

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  LoadingDots,
} from '@/components/ui'

interface DeleteCartButtonProps {
  cartId: string
}

export const DeleteCartButton = ({ cartId }: DeleteCartButtonProps) => {
  const { mutate: deleteCart, isPending } = useDeleteCart()
  const [open, setOpen] = React.useState(false)

  const handleDelete = React.useCallback(() => {
    deleteCart(cartId, {
      onSuccess: () => {
        setOpen(false)
      },
    })
  }, [cartId, deleteCart])

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" className="shadow-card" disabled={isPending}>
          {isPending ? (
            <LoadingDots />
          ) : (
            <TrashBin2Broken className="size-5" />
          )}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Order?</AlertDialogTitle>
          <AlertDialogDescription>
            You are about to delete this saved order. This action cannot be
            undone. Are you sure you want to proceed?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="w-full" disabled={isPending}>
            Close
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            disabled={isPending}
            onClick={handleDelete}
            className="w-full"
            autoFocus
          >
            {isPending ? <LoadingDots /> : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

